export default __webpack_public_path__ + "media/Crowd_mobile.2f5869cdb954cd8a012bc7b75fb9e34e.svg";